import type { Selection } from '@atlaskit/editor-prosemirror/state';
import type { ContentNodeWithPos } from '@atlaskit/editor-prosemirror/utils';

import { TableMap } from '../table-map';
import { findTable } from './find-table';

// Returns an array of cells in a row(s), where `rowIndex` could be a row index or an array of row indexes.
export const getCellsInRow =
	(rowIndex: number | number[]) =>
	(selection: Selection): ContentNodeWithPos[] | undefined => {
		const table = findTable(selection);
		if (!table) {
			return;
		}

		const map = TableMap.get(table.node);
		const indexes = Array.isArray(rowIndex) ? rowIndex : [rowIndex];

		return indexes
			.filter((index) => index >= 0 && index <= map.height - 1)
			.reduce<ContentNodeWithPos[]>((acc, index) => {
				const cells = map.cellsInRect({
					left: 0,
					right: map.width,
					top: index,
					bottom: index + 1,
				});
				return acc.concat(
					cells.map((nodePos) => {
						// Ignored via go/ees005
						// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
						const node = table.node.nodeAt(nodePos)!;
						const pos = nodePos + table.start;
						return { pos, start: pos + 1, node, depth: table.depth + 2 };
					}),
				);
			}, []);
	};
